import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const OverviewCard = styled.div`
  width: 100%;
  margin: 0px 8px 16px 8px;
  padding-bottom: 4px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15);
`;

OverviewCard.propTypes = {
  minHeight: PropTypes.number,
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
OverviewCard.defaultProps = {
  cols: 1,
};
export default OverviewCard;
